import http from './http';

export async function listRoomReports(params) {
  const { data } = await http.get('/room-reports', { params });
  return data;
}

export async function listRoomReportsCount(params) {
  const { data } = await http.get('/room-reports/count', { params });
  return data; // { total }
}

export async function createRoomReport(payload) {
  const { data } = await http.post('/room-reports', payload);
  return data;
}

export async function updateRoomReport(id, payload) {
  const { data } = await http.put(`/room-reports/${id}`, payload);
  return data;
}

export async function deleteRoomReport(id) {
  const { data } = await http.delete(`/room-reports/${id}`);
  return data;
}

export async function listMyRoomReports() {
  const { data } = await http.get('/room-reports/mine');
  return data;
}

export async function listMyRoomReportsCount() {
  const { data } = await http.get('/room-reports/mine/count');
  return data; // { total }
}

export async function signRoomReport(id) {
  const { data } = await http.post(`/room-reports/${id}/sign`);
  return data;
}

export async function rejectRoomReport(id) {
  const { data } = await http.post(`/room-reports/${id}/reject`);
  return data;
}

export async function applyHoldRoomReport(id, payload) {
  const { data } = await http.post(`/room-reports/${id}/apply-hold`, payload);
  return data;
}

export async function finalizeRoomReport(id) {
  const { data } = await http.post(`/room-reports/${id}/finalize`);
  return data;
}

export async function createMoveOutRoomReport(id, payload) {
  const { data } = await http.post(`/room-reports/${id}/create-move-out`, payload);
  return data;
}
